import styled, { css } from "styled-components";

export const IconContainer = styled.div.attrs({ className: "icon-container" })(({ theme }) => css`
  background-color: ${theme.palette.text.body};
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.palette.text.body};

  &.red-background {
    background-color: ${theme.palette.input.error};
    border: 1px solid ${theme.palette.input.error};
  }
`);